module.exports = "#SidebarButtons ul {\n  position: fixed;\n  left: 0;\n  top: 0;\n}\n/*# sourceMappingURL=src/app/sidebar/sidebar.component.css.map */"